import * as React from 'react';
import c from 'classnames';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { DynamicMediaItem, TargetAudienceCard } from '../../../../components';
import { TaxonomyTargetAudience } from '../../../../types/uncinc_profile/taxonomy';

interface TargetAudienceProps {
  entity: ImmutableEntity<TaxonomyTargetAudience>;
  aboveTheFold?: Boolean;
  className?: string;
}

const TaxonomyTargetAudienceTeaser: React.FC<TargetAudienceProps> = ({
  entity,
  aboveTheFold = false,
  className,
}) => {
  const classes = c('TaxonomyTargetAudienceTeaser', className);
  const targetAudience = entity.toJS();

  const language = targetAudience.langcode[0].value;
  const path = targetAudience.paths[language];
  const name = targetAudience.name[0].value;
  const description = targetAudience.description[0].processed;
  const media = targetAudience.field_media_item[0];

  return (
    <TargetAudienceCard
      className={classes}
      type="secondary"
      title={name}
      subtitle={description ?? undefined}
      link={path}
      image={<DynamicMediaItem media={media} imageAspectRatio="4_3" aboveTheFold={aboveTheFold} />}
    />
  );
};

export default TaxonomyTargetAudienceTeaser;
